import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import PageContent from "@my-dld/components/PageContent";
import Strings from "@my-dld/assets/strings";
import PageTitle from "@my-dld/components/PageTitle";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import { MSChargeInvoice } from "@eres/mollakservicechargeapi/entities";
import { loadMSChargeInvoices } from "@eres/mollakservicechargeapi/api";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import ListDataView from "@my-dld/components/DataView/ListDataView";
import { CurrencyUtil, I8N, LocaleUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import { navigate } from "@my-dld/utils/StoreUtils";
import { Entities, PropertyRegistryApi } from "@10x/dubai-rest-api";
import { IMSCData, MSCContext } from "@my-dld/contexts/MSCContext";

interface Props extends RoutedViewProps {

}

interface State extends IMSCData {

}

class MollakServiceCharges extends Component<Props, State> {
	static contextType = MSCContext;
	context!: React.ContextType<typeof MSCContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {};
	}

	componentDidMount() {
		const data: IMSCData | undefined = this.context.getData( "MSCharges" );
		if ( data && data.summary && data.invoices ) {
			this.setState( {
				summary: data.summary,
				invoices: data.invoices,
			}, this.configDataTable );
		} else {
			this.loadServiceCharges();
		}
	}

	render() {
		const { summary, invoices } = this.state;
		return <PageContent
			title={ Strings.mollak_service_charges }
			hideQLinks={ true }>
			<PageTitle title={ Strings.mollak_service_charges } paths={ [ DashboardBCItem ] }/>
			{ summary && <div className="alert alert-info d-flex align-items-center">
				<span>{ Strings.total_msc_due_all_props }</span>
				<span className="font-20 font-weight-bold ms-2">
                    { CurrencyUtil.toSimpleCurrency( summary.totalBilled ) }</span>
			</div> }
			{ invoices && <ListDataView
				title={ Strings.property_invoices }
				items={ invoices }
				renderListHeader={ () => <RenderHeader/> }
				renderListItem={ ( item: MSChargeInvoice ) => {
					return <RenderListItem
						key={ "invoice_" + item.invoiceRefNumber }
						item={ item }/>;
				} }/> }
		</PageContent>;
	}

	private configDataTable = () => {
		try {
			window.$( "#ListView" ).DataTable( {
				//language: LocaleUtil.Select( DataTableLang ),
                language: { url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/" + (I8N.current == "ar" ? "Arabic.json" : "English.json"), lengthMenu: '_MENU_' },
                dom: "<'table-responsive'rt>" + "<'dt-cfooter'i<'dt-fpl'pl>>",
                pagingType: "simple_numbers",
				responsive: false,
				lengthChange: false,
				scrollX: true
			} );
			const onDetails = this.onDetails;
			window.$( "#ListView" ).on( "click", "a", function () {
				// @ts-ignore
				let item = JSON.parse( this.getAttribute( "data-item" ) );
				if ( item )
					onDetails( item );
				return false;
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};

	private loadServiceCharges() {
		showLoading();
		loadMSChargeInvoices().then( ( response: any ) => {
			this.setState( {
				summary: response.summary,
				invoices: response.invoices,
			}, () => {
				this.configDataTable();
				this.context.setData( "MSCharges", this.state );
			} );
			hideLoading();
		} ).catch( e => {
			this.setState( {
				invoices: [],
			}, this.configDataTable );
			hideLoading();
			showErrorMessage( e );
		} );
	}

	private onDetails = ( item: MSChargeInvoice ) => {
		showLoading();
		PropertyRegistryApi.loadAssetByPropertyId( item.propertyId )
		.then( Entities.validateResponse )
		.then( r => {
			hideLoading();
			if ( r.cards && r.cards.length > 0 ) {
				const property = r.cards[ 0 ];
				navigate( `/mydld/mollak_service_charges/${ property.propertyTypeId }/${ property.propertyId }`,
					undefined, { property: property } );
			} else {
				showErrorMessage( Strings.no_data_found );
			}
		} ).catch( r => {
			hideLoading();
			showErrorMessage( r );
		} );
	};
}

function RenderHeader() {
	return <tr>
		<th>{ Strings.Unit_Number_Label }</th>
		<th>{ Strings.building_name }</th>
		<th>{ Strings.total_payable }</th>
		<th>{ Strings.action }</th>
	</tr>;
}

function RenderListItem( props: { item: MSChargeInvoice } ) {
	const { item } = props;
	const due = item?.dueAmount ? Number( item.dueAmount ) : 0;
	return <tr>
		<td data-label={ Strings.Unit_Number_Label }>{ item.propertyNumber }</td>
		<td data-label={ Strings.building_name }>{ LocaleUtil.getLocalValue( item.propertyGroup ) }</td>
		<td data-label={ Strings.total_payable }>{ CurrencyUtil.toSimpleCurrency( due ) + " " + Strings.aed }</td>
		<td>
			<a
				href="#"
				data-item={ JSON.stringify( item ) }
				className="btn-link">{ Strings.view_details }</a>
		</td>
	</tr>;
}

export default MollakServiceCharges;
